import { useState } from "react";
import { defaultMetadataState, MetaData, type PageMetadata } from "../hooks";

export function MetadataProvider({
  children,
  initialMetadata,
}: {
  children: React.ReactNode;
  initialMetadata?: PageMetadata;
}) {
  const [metadata, setMetadata] = useState<PageMetadata[]>(
    initialMetadata ? [initialMetadata] : defaultMetadataState.metadata
  );

  const pushMetadata = (page: PageMetadata) => setMetadata((pages) => [...pages, page]);
  const popMetadata = () => setMetadata((pages) => pages.slice(0, -1));

  const handleMetadata = (page: PageMetadata) => {
    pushMetadata(page);
    return () => popMetadata();
  };

  const value = {
    metadata,
    handleMetadata,
  };

  return <MetaData.Provider value={value}>{children}</MetaData.Provider>;
}
